import firebase from '@/infra/firebase';
import { Item } from '@/models/item';
import { IOrder } from '@@functions/models';
import axios from 'axios';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

const urlFucntionGen2 =  process.env.VUE_APP_API_GEN_2

const date = moment(new Date()).subtract(1, 'year').format('YYYY-MM-DD');
let getBookedLimit = 200;
let getBookedStartAt = 0
let currentOffset = 0;
let totalProcessed = 0;
let initialTotalRecords = 0; 

export default {
  getOrdersAndBookingItems(cb?: (items: any) => void) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: { 
          orderDate: date,
        },
        url: urlFucntionGen2+ "getOrdersGen2"
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
    // return new Promise((resolve, reject) => {
    //   firebase.instance.functions
    //     .httpsCallable('getOrders')(date)
    //     .then(
    //       (resp) => resolve(resp.data),
    //       (err) => reject(err)
    //     );
    // });
  },
  resetGetBookedStartAt() {
    getBookedStartAt = 0;
  },
  getBookedItems(cb?: (items: any) => void) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: urlFucntionGen2+"getBookedListGen2",
        headers: {
          'Content-Type': 'application/json', 
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
        },
        data: {
          limit: 100,
          offset: 0, 
          orderDate: date,
        },
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('getBookedList')({limit:100, offset:0, orderDate:date})
      //   .then(
      //     (resp) => resolve(resp.data),
      //     (err) => reject(err)
      //   );
    });
  },
  getBookedItemsMore(cb?: (items: any) => void) {
    return new Promise((resolve, reject) => {
      getBookedStartAt += getBookedLimit;
      axios({
        method: 'POST',
        url: urlFucntionGen2+"getBookedListGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
        },
        data: {limit:getBookedLimit, offset:getBookedStartAt-100, orderDate:date},
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('getBookedList')({limit:getBookedLimit, offset:getBookedStartAt-100, orderDate:date})
      //   .then(
      //     (resp) => resolve(resp.data),
      //     (err) => reject(err)
      //   );
    });
  },
  async filterBooked(params: any) {
    // return await firebase.instance.functions
    //     .httpsCallable('filterBooked')(params)
    return new Promise((resolve, reject) => {
    axios({
      method: 'POST', // Phương thức POST
      url: urlFucntionGen2+"filterBookedGen2",
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
      },
      data: params,
    })
    .then((resp) => {
      resolve(resp);
    })
    .catch((err) => {
      reject(err);
    });
  });
  },
  save(item: Item) {
    return new Promise((resolve, reject) => {
      if (
        item.conditionChecked &&
        item.transportToName != '' &&
        item.transportVendorId != '' &&
        item.checkDupplicateVinNo &&
        item.vinNo != 'new order'
      ) {
        if (item.transportRequestConfirmDate) {
          item.status = 2;
          item.isUpdate = 1;
        } else {
          item.status = 1;
        }
      } else {
        item.status = 0;
      }
      item.isDailyUpdateChecked = '1';
      axios({
        method: 'POST',
        url: urlFucntionGen2+"updateOrderGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
        },
        data: item,
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('updateOrder')(item)
      //   .then(
      //     (resp) => resolve(resp.data),
      //     (err) => reject(err)
      //   );
    });
  },
  // Task199 start
  async updateVinNoFirebase(data: any) {
    return new Promise((resolve, reject) => {
        axios({
        method: 'POST',
        url: urlFucntionGen2+"updateVinNoByMatterNoGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
        },
        data: data, 
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('updateVinNoByMatterNo')(data)
      //   .then(
      //     (resp) => resolve(resp.data),
      //     (err) => reject(err)
      //   );
    });
  },
  // Task199 end
  sync(autionsVendor: any) {
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"updateOrdersGen2", 
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
      },
      data: autionsVendor,
      })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('updateOrders')(autionsVendor)
      //   .then(
      //     (resp) => resolve(resp),
      //     (err) => reject(err)
      //   );
    });
  },
  delete(orderId: string) {
   
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"deleteOrderAndReferencesGen2",
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
      },
      data: { orderId: orderId },
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('deleteOrderAndReferences')(orderId)
      //   .then(
      //     (resp) => resolve(resp.data),
      //     (err) => reject(err)
      //   );
    });
    
  },
  async create() {
    const o = new Item({
      id: uuidv4(),
      orderDate: moment().format('YYYY-MM-DD'),
      vinNo: 'new order',
      newRequestTransportFlg: 'true',
    } as IOrder);
    
    return new Promise((resolve, reject) => {
      const dataToSend = {
      id: o.id,
      data: o.getData(),
      };

      axios({
        method: 'POST',
        url: urlFucntionGen2+"createOrderGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
        },
        data: dataToSend,
      })
      .then((resp) => {
        resolve(o);
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('createOrder')({id: o.id, data:o.getData()})
      //   .then(
      //     (resp) => resolve(o),
      //     (err) => reject(err)
      //   );
    });
  },
  async createNewTransport(item: IOrder) {
    if (
      item.conditionChecked &&
      item.transportToName != '' &&
      item.transportVendorId != '' &&
      item.checkDupplicateVinNo &&
      item.vinNo != 'new order'
    ) {
      if (item.transportRequestConfirmDate) {
        item.status = 2;
        item.isUpdate = 1;
      } else {
        item.status = 1;
      }
    } else {
      item.status = 0;
    }
    
    return new Promise((resolve, reject) => {
      const o = new Item(item);
      if(o.id==''){
        o.id = uuidv4()
      }
      axios({
        method: 'POST',
        url: urlFucntionGen2+"createOrderGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
        },
        data: {id: o.id, data:o.getData()},
      })
      .then((resp) => {
        resolve(o); 
      })
      .catch((err) => {
        reject(err);
      });
      // firebase.instance.functions
      //   .httpsCallable('createOrder')({id: o.id, data:o.getData()})
      //   .then(
      //     (resp) => resolve(o),
      //     (err) => reject(err)
      //   );
    });
  },
  async bookedRevert(data: any) {
    
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"getOrderBookedRevertByMatterNoAndOrderDateGen2", 
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
      },
      data: data, 
      })
      .then((resp) => {
        const rs = (resp.data) ? new Item(resp.data as IOrder) : null;
        resolve(rs);
      })
      .catch((err) => {
        reject(null); 
      });
      // firebase.instance.functions
      //   .httpsCallable('getOrderBookedRevertByMatterNoAndOrderDate')(data)
      //   .then(
      //     (resp) => {
      //       const rs = (resp.data) ? new Item(resp.data as IOrder) : null
      //       resolve(rs)
      //     },
      //     (err) => reject(null)
      //   );
    });
  },
  async bookedRevert1(data: any) {
    
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: urlFucntionGen2+"getOrdersBookedRevertByMatterNoGen2",
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
        },
        data: data,
      })
      .then((resp) => {
        const rs = (resp.data as any[]).map((x: any) => x as IOrder);
        resolve(rs);
      })
      .catch((err) => {
        reject(null); 
      });
      // firebase.instance.functions
      //   .httpsCallable('getOrdersBookedRevertByMatterNo')(data)
      //   .then(
      //     (resp) => {
      //       resp.data.map((x: any) => x as IOrder);
      //       resolve(resp.data)
      //     },
      //     (err) => reject(null)
      //   );
    });
  },

  async updateImageFireBase(offset:number = 0) {
      const data = {
        offset: offset,
        limit: 20
      }

    return new Promise(async (resolve, reject) => {
      try {
        const dataToSend = {
          offset: currentOffset,
          limit: 100,
          initialTotalRecords: initialTotalRecords, 
          totalRecordsFromPreviousRun: totalProcessed 
        };

        const resp = await axios({
          method: 'POST',
          url: urlFucntionGen2+"updateImageFireBaseGen2",
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
          },
          data: dataToSend,
        });

        const responseData = resp.data; 

        currentOffset = responseData.offset;
        initialTotalRecords = responseData.totalFirebaseRecords;
        totalProcessed = responseData.totalProcessedSoFar;


        if (responseData.isContinue) {
          setTimeout(() => {
            this.updateImageFireBase(currentOffset)
              .then(resolve)
              .catch(reject);
          }, 100);
        } else {
          resolve(responseData);
        }

      } catch (err: any) {
        reject(null);
      }
      // firebase.instance.functions
      //   .httpsCallable('updateImageFireBase')(data)
      //   .then(
      //     (resp) => {
      //       resolve(resp.data)
      //         if(resp.data.isContinue){
      //           this.updateImageFireBase(resp.data.offset);
      //         }
            
      //     },
      //     (err) => reject(null)
      //   );
    });
  },
  async getHistoryTransports(params: any) {
    return new Promise((resolve, reject) => {
    axios({
      method: 'POST', 
      url: urlFucntionGen2+"getHistoryTransportsGen2",
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
      },
      data: params, 
    })
    .then((resp) => {
      resolve(resp); 
    })
    .catch((err) => {
      reject(null); 
    });
  });
    // return await firebase.instance.functions
    //     .httpsCallable('getHistoryTransports')(params)
  },
  // async updateDataFirebase(auction: any[], yard:any[], offset:number = 0, limit:number = 20 ) {

  //   const data = {
  //     auction: auction,
  //     yard: yard,
  //     offset: offset,
  //     limit: limit
  //   }

  //   return new Promise((resolve, reject) => {
  //     firebase.instance.functions
  //       .httpsCallable('updateDataFirebase')(data)
  //       .then(
  //         (resp) => {
  //           resolve(resp)
  //           if(resp.data.isContinue){
  //             this.updateDataFirebase(auction,yard,resp.data.offset);
  //           }
  //         },
  //         (err) => reject(null)
  //       );
  //   });
  // },
  async getListUpdateCustomers(matterNo: any) {
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"getListUpdateCustomersGen2", 
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
      },
      data: { matterNo: matterNo }, 
      })
      .then((resp) => {
        const rs = (resp.data as any[]).map((x: any) => x as IOrder);
        resolve(rs);
      })
      .catch((err) => {
        reject(null);
      });
      // firebase.instance.functions
      //   .httpsCallable('getListUpdateCustomers')(matterNo)
      //   .then(
      //     (resp) => {
      //       resp.data.map((x: any) => x as IOrder);
      //       resolve(resp.data)
      //     },
      //     (err) => reject(null)
      //   );
    });
  },
  async getItemById(id: any) {
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"getItemByIdGen2",
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
      },
      data: { id: id },
    })
    .then((resp) => {
      const rs = (resp.data) ? new Item(resp.data as IOrder) : null;
      resolve(rs);
    })
    .catch((err) => {
      reject(err); 
    });
      // firebase.instance.functions
      //   .httpsCallable('getItemById')(id)
      //   .then(
      //     (resp) => {
      //       const rs = (resp.data) ? new Item(resp.data as IOrder) : null
      //       resolve(rs)
      //     },
      //     (err) => reject(err)
      //   );
    });
  },
  async getListItemByVinNo(vinNo: any) {
    return new Promise((resolve, reject) => {
      axios({
      method: 'POST',
      url: urlFucntionGen2+"getListItemByVinNoGen2",
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(), 
      },
        data: { vinNo: vinNo },
      })
      .then((resp) => {
        const rs = (resp.data as any[]).map((x: any) => x as IOrder);
        resolve(rs);
      })
      .catch((err) => {
        reject(null); 
      });
      // firebase.instance.functions
      //   .httpsCallable('getListItemByVinNo')(vinNo)
      //   .then(
      //     (resp) => {
      //       resp.data.map((x: any) => x as IOrder);
      //       resolve(resp.data)
      //     },
      //     (err) => reject(null)
      //   );
    });
  },
};
